var underscore = angular.module('underscore', []);
underscore.factory('_', ['$window', function ($window) {

    _.mixin({
        remove: function(obj, keys){
            for(var i=0; i < keys.length; i++){
                delete obj[keys[i]];
            }
            return obj;
        }
    });

    return $window._; // assumes underscore has already been loaded on the page
}]);

var forestApp = angular.module('forestApp', [
    'ui.router',
    'ui.bootstrap',
    'localytics.directives',
    'angular-loading-bar',
    'forestControllers',
    'forestServices',
    'forestDirectives',
    'dialogs.main',
    'angularUtils.directives.dirPagination',
    'checklist-model',
    'ngAnimate',
    'ngResource',
    'underscore',
    'ngMessages',
    'ngNotificationsBar',
    'ngSanitize',
    'smart-table'
]);

forestApp.config(['notificationsConfigProvider', function (notificationsConfigProvider) {
    notificationsConfigProvider.setAcceptHTML(true);
}]);

forestApp.config(['$httpProvider', '$stateProvider', '$urlRouterProvider', '$provide',
    function ($httpProvider, $stateProvider, $urlRouterProvider, $provide) {

        //  Checks if request returned 401 status code.
        //  before anything else happens.

        $httpProvider.defaults.headers.get = {'X-NG': 'NG'};

        $provide.factory('authInterceptor', function ($q, $injector, $rootScope) {
            return {
                responseError: function (rejection) {
                    if (rejection.status === 401) {

                        // This var may be set to true in current instance of app
                        // but we need to reset it if someone log outs from
                        // other window/computer or session expires
                        $rootScope.authed = false;

                        $injector.get('$state').go('login');
                    }

                    return $q.reject(rejection);
                }
            };
        });

        $httpProvider.interceptors.push('authInterceptor');

        //$urlRouterProvider.when('/main', '/main/first');

        //$urlRouterProvider.otherwise('/main');

        $stateProvider
            .state('login', {
                url: '/login',
                controller: 'authController',
                templateUrl: '/views/auth',
                data: {requireLogin: false}
            })
            .state('app', {
                abstract: true,
                url: '/main',
                resolve: {

                    // Get AngularJS resource to query
                    Server: 'Server',

                    // Use the resource to fetch data from the server
                    tanrigisCxrili: function (Server) {
                        return Server.getTreesTanrigi();
                    },
                    dropDownData: ['Server', function (Server) {
                        return Server.getDropDownData();
                    }],
                    UserSettings: ['Settings', function (Settings) {
                        return Settings.get().$promise
                    }]

                    /*
                     // Extract the configuration data
                     // that we need for the home state
                     data: function(config){
                     return config.homeConfigData;
                     }*/
                },
                template: '<ui-view/>'
            })
            .state('app.forest-cut', {
                url: '/forest-cut/{dupl}/duplicate',
                templateUrl: '/views/dashboard',
                controller: 'mainController',
                resolve: {
                    userInput: ['Server', '$stateParams', function (Server, $stateParams) {
                        return $stateParams.dupl ? Server.getPassportData($stateParams.dupl) : null;
                    }],
                    forma6: ['Server', '$stateParams', function (Server, $stateParams) {
                        return $stateParams.dupl ? Server.getForma6Data($stateParams.dupl) : null;
                    }],
                    forma1: ['Server', '$stateParams', function (Server, $stateParams) {
                        return $stateParams.dupl ? Server.getTrees($stateParams.dupl) : null;
                    }]
                },
                data: {requireLogin: true}
            })
            .state('app.forest-cut-edit', {
                url: '/forest-cut/edit/{edit}',
                templateUrl: '/views/dashboard',

                resolve: {
                    userInput: ['Server', '$stateParams', function (Server, $stateParams) {
                        return Server.getPassportData($stateParams.edit);
                    }],
                    forma6: ['Server', '$stateParams', function (Server, $stateParams) {
                        return Server.getForma6Data($stateParams.edit);
                    }],
                    forma1: ['Server', '$stateParams', function (Server, $stateParams) {
                        return Server.getTrees($stateParams.edit);
                    }]
                },
                controller: 'mainController',
                data: {requireLogin: true}
            })
            .state('app.welcome', {
                url: '/welcome',
                templateUrl: '/views/welcome',
                controller: 'welcomeController',
                data: {requireLogin: true}
            })
            .state('admin', {
                url: '/admin-forms',
                templateUrl: '/views/admin-forms',
                controller: 'adminFormsController',
                data: {requireLogin: true}
            })
            .state('app.sataqsacio-barati', {
                url: '/sataqsacio-barati',
                templateUrl: '/views/sb',
                resolve: {
                    sbDropDownData: ['Server', function (Server) {
                        return Server.getSbDropDownData();
                    }]
                },
                controller: 'sataqsacioBaratiController',
                data: {requireLogin: true}
            })
            .state('app.sataqsacio-barati.kvartali', {
                url: '/kvartali/{satyeo_id}',
                templateUrl: '/views/sb-kvartali',
                resolve: {
                    sbKvartalis: ['Server', '$stateParams', function (Server, $stateParams) {
                        return Server.getSbKvartalis($stateParams.satyeo_id)
                    }]
                },
                controller: 'sbKvartaliController',
                data: {requireLogin: true}
            })
            .state('app.sataqsacio-barati.literi', {
                url: '/literi/{satyeo_id}/{kvartali}',
                templateUrl: '/views/sb-literi',
                resolve: {
                    sbLiteris: ['Server', '$stateParams', function (Server, $stateParams) {
                        return Server.getSbLiteris($stateParams.satyeo_id, $stateParams.kvartali)
                    }],

                    prevExists: ['Server', '_', '$stateParams', '$q', function (Server, _, $stateParams, $q) {

                        /**
                         * Prevent new kvartali state access if previous kvartali does not exist
                         */
                        var deferred = $q.defer();

                        Server.getSbKvartalis($stateParams.satyeo_id).then(function (kvartalis) {

                            var check = parseInt($stateParams.kvartali) - 1;
                            if (_.where(kvartalis, {kvartali: check}).length > 0 || $stateParams.kvartali == 1) {
                                deferred.resolve("Previous kvartali does exist.");
                            } else {
                                deferred.reject("Previous kvartali does not exist.");
                            }
                        }).catch(function () {
                            deferred.reject("Previous kvartali does not exist.");
                        });

                        return deferred.promise;
                    }]
                },
                controller: 'sbLiterebiController',
                data: {requireLogin: true}
            })
            .state('app.sataqsacio-barati.input', {
                url: '/input/{satyeo_id}/{kvartali}/{literi}',
                templateUrl: '/views/sb-input',
                resolve: {
                    existingData: ['Server', '$stateParams', function (Server, $stateParams) {
                        return Server.getSbData($stateParams.satyeo_id, $stateParams.kvartali, $stateParams.literi)
                    }],

                    prevExists: ['Server', '_', '$stateParams', '$q', function (Server, _, $stateParams, $q) {

                        /**
                         * Prevent new literi input state access if previous literi does not exist
                         */
                        var deferred = $q.defer();

                        Server.getSbLiteris($stateParams.satyeo_id, $stateParams.kvartali).then(function (literis) {

                            var check = parseInt($stateParams.literi) - 1;

                            if (_.where(literis, {literi: check}).length > 0 || $stateParams.literi == 1) {
                                deferred.resolve("Previous literi does exist.");
                            } else {
                                deferred.reject("Previous literi does not exist.");
                            }
                        }).catch(function () {
                            deferred.reject("Previous literi does not exist.");
                        });

                        return deferred.promise;
                    }]
                },
                controller: 'sbInputController',
                data: {requireLogin: true}
            })
            .state('app.sataqsacio-barati.not-chosen', {
                url: '/not-chosen',
                template: '<h1 class="text-center">გთხოვთ აირჩიოთ <br><strong>{{note}}</strong></h1>',
                data: {requireLogin: true}
            });
    }]);

forestApp.run(['$rootScope', '$state', 'User', '$animate', function ($rootScope, $state, User, $animate) {
    //Set inital value of auth to false after page was refreshed

    $rootScope.showSpinner = false;

    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
        //if (toState.resolve) {
        $rootScope.showSpinner = true;
        //}
    });

    $rootScope.$on('$stateChangeStart', function () {
        $rootScope.showSpinner = true;
    });

    $rootScope.$on('$stateChangeSuccess', function () {
        $rootScope.showSpinner = false;
    });

    $rootScope.$on('$stateChangePrevented', function () {
        $rootScope.showSpinner = false;
    });

    $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
        console.log(error);
        $rootScope.showSpinner = false;
    });

    $rootScope.$on('$stateChangeSuccess', function (ev, to, toParams, from, fromParams) {
        $rootScope.oldState = from;
    });

    $rootScope.authed = false;

    $state.go('app.welcome');

    $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
        var requireLogin = toState.data.requireLogin;

        console.log('statechange start');

        if (requireLogin) {

            User.isAuthed()
                .then(function () {
                    //console.log('Authentication required checking auth success');
                })
                .catch(function () {
                    event.preventDefault();
                    $state.go('login');
                });
        }

        if (toState.name === 'login') {
            User.isAuthed()
                .then(function () {
                    console.log('got here');
                    $state.go('app.welcome');
                });
        }
    });
}]);